import { rankWith, uiTypeIs } from '@jsonforms/core';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import parse from 'html-react-parser';

const HTMLRenderer = props => {
  const { uischema } = props;

  const html = uischema.options?.html;

  return (
    <>
      {parse(html)}
    </>
  );
};

//     <div style={{ margin: '8px 0px' }}>
//       <h5 style={{ textAlign: 'center', fontSize: '18px' }}>STATUS UCZNIA SZKOŁY PONADPODSTAWOWEJ/ STUDENTA
// do 26 roku życia <br></br> dla celów ustalenia podlegania zleceniobiorcy do ubezpieczeń w ZUS:</h5>
//       <section style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
//         <article style={{ width: '400px' }}>
//           <header style={{ backgroundColor: '#ddd', fontWeight: 'bold', textAlign: 'center', padding: '12px 0px', border: '1px solid black' }}>Szkoła:</header>
//           <div style={{ border: '1px solid black', padding: '4px 8px', height: '340px' }}>
//             <p><b>Ponadpodstawowa:</b></p>
//             <ul style={{ listStyle: 'none' }}>
//               <li>- liceum ogólnokształcące,</li>
//               <li>- technikum,</li>
//               <li>- szkoła branżowa I i II stopnia,</li>
//               <li>- szkoła policealna.</li>
//             </ul>
//           </div>
//           <div style={{ border: '1px solid black', padding: '4px 8px', height: '285px' }}>
//             <p><b>Studia na poziomach:</b></p>
//             <ul style={{ listStyle: 'none' }}>
//               <li>- I stopnia licencjat,</li>
//               <li>- II stopnia magister</li>
//               <li>- jednolite magisterskie</li>
//             </ul>
//             <p><b>UWAGA!</b></p>
//             <p>Nie mają statusu studenta studenci studiów jedynie podyplomowych i studiów doktoranckich.</p>
//           </div>
//         </article>
//         <article style={{ width: '400px' }}>
//           <header style={{ backgroundColor: '#ddd', fontWeight: 'bold', textAlign: 'center', padding: '12px 0px', border: '1px solid black' }}>Okres obowiązywania statusu ucznia/studenta:</header>
//           <div style={{ border: '1px solid black', height: '340px' }}>
//             <div style={{ borderBottom: '1px solid black', padding: '4px 8px' }}>
//               <p>Status ucznia obowiązuje od dnia rozpoczęcia
//   szkoły ponadpodstawowej do 31 sierpnia każdego
//   roku w przypadku:</p>
//               <ul style={{ listStyle: 'none' }}>
//                 <li>- kontynuowania nauki w tej samej szkole,</li>
//                 <li>- ukończenia szkoły i rozpoczęcia nauki w szkole. której rok rozpoczyna się 1 września.</li>
//                 <li>- ukończenia szkoły i niekontynuowania nauki</li>
//               </ul>
//             </div>
//             <p style={{ padding: '4px 8px' }}>Ponadto status ucznia szkoły ponadpodstawowej obowiązuje do 30 września w roku między ukończeniem szkoły ponadpodstawowej, a przyjęciem na studia pod warunkiem, że osoba przedstawi zaświadczenie o przyjęciu na studia wyższe.</p>
//           </div>
//           <div style={{ border: '1px solid black', height: '285px' }}>
//             <div style={{ borderBottom: '1px solid black', padding: '4px 8px' }}>
//               <p>Status studenta obowiązuje od daty przyjęcia na studia <b>do dnia obrony (egzaminu dyplomowego)</b> lub <b>skreślenia z listy studentów</b></p>
//             </div>
//             <div style={{ padding: '4px 8px' }}>
//               <p>Wyjątki na <b>wybranych kierunkach</b> studiów:</p>
//               <ul style={{ listStyle: 'none' }}>
//                 <li>- studia na kierunkach lekarskim, lekarsko- dentystycznym i weterynaria-status studenta obowiązuje do daty złożenia ostatniego
//   wymaganego programem studiów egzaminu,</li>
//                 <li>- studia na kierunkach farmacja i fizjoterapia
//   status studenta obowiązuje do daty zaliczenia ostatniej wymaganej programem studiów praktyki.</li>
//               </ul>
//             </div>
//           </div>
//         </article>
//       </section>
//     </div>

export default withJsonFormsLayoutProps(HTMLRenderer);

export const HTMLRendererTester = rankWith(1000, uiTypeIs('HTMLRenderer'));
